import React from "react";

const HoverList = ({data}) => {
    if  (!data || data.length === 0) {
        return null
    }
    console.log(data, 'HoverList data');
    
  return (
    <div className="bg-white shadow-lg p-4 rounded-lg">
      <ul className="list-disc text-sm whitespace-nowrap">
        {data?.sort()?.map((item, index) => (
          <ul key={`list1-${index}`}>{item}</ul>
        ))}
      </ul>
    </div>
  );
};

export default HoverList;
